export default "__VITE_ASSET__Cqt8P7R1__"